<template>
  <router-view/>
</template>

<script>
export default {
  name:'App',
  mounted(){
    const windowWidth = document.documentElement.scrollWidth
    const raito = windowWidth / 375
    document.documentElement.style.setProperty('--raito', raito)
  }
}
</script>

<style>

</style>